import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * The funding import that runs in the background (owner, 2026-09-28: "continue in
 * background ... ça devrait afficher la progression en bas à droite et la possibilité
 * d'ouvrir la fenêtre en recliquant dessus").
 *
 * Global so that the dock follows the import on every page; persisted so that a
 * refresh keeps it. `openRequest` asks the funding dialog of the companies page to
 * open on the import: the dock sets it, the dialog consumes it. `viewing` is the import
 * the dialog shows, which the dock does not repeat.
 */
export interface TrackedFundingImport {
  slug: string;
  importId: string;
  filename: string;
}

interface FundingImportState {
  tracked: TrackedFundingImport | null;
  openRequest: { importId: string; nonce: number } | null;
  viewing: string | null;
  track: (value: TrackedFundingImport) => void;
  dismiss: () => void;
  requestOpen: (importId: string) => void;
  clearOpenRequest: () => void;
  setViewing: (importId: string | null) => void;
}

export const useFundingImportStore = create<FundingImportState>()(
  persist(
    (set) => ({
      tracked: null,
      openRequest: null,
      viewing: null,
      track: (value) => set({ tracked: value }),
      dismiss: () => set({ tracked: null }),
      requestOpen: (importId) => set({ openRequest: { importId, nonce: Date.now() } }),
      clearOpenRequest: () => set({ openRequest: null }),
      setViewing: (importId) => set({ viewing: importId }),
    }),
    {
      name: "prism.funding-import",
      // Only the tracked import survives a refresh; the rest is this page's state.
      partialize: (state) => ({ tracked: state.tracked }),
    },
  ),
);
